// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"d8bc7bad","453":"4fd2081b","455":"2759114b","768":"bb340c12","977":"55965cca"}[chunkId] + ".chunk.js";
};